var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid overflow-y-auto mb-4"},[_c('update-team-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }